import { render, staticRenderFns } from "./EditStaffPage.vue?vue&type=template&id=34edbcf6&scoped=true&"
import script from "./EditStaffPage.vue?vue&type=script&lang=js&"
export * from "./EditStaffPage.vue?vue&type=script&lang=js&"
import style0 from "./EditStaffPage.vue?vue&type=style&index=0&id=34edbcf6&prod&lang=scss&scoped=true&"
import style1 from "./EditStaffPage.vue?vue&type=style&index=1&id=34edbcf6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34edbcf6",
  null
  
)

export default component.exports